import styled from 'styled-components';
export const Container = styled.div `
  position: absolute;
  top: -6px;
  right: -6px;

  border: 2px solid var(--border-active-invert);
  border-radius: var(--radius-brand);
  padding: 0px 4px;

  background: var(--bg-primary-invert);

  text-align: center;
  color: var(--text-primary-invert);
  text-align: center;
  font-size: var(--font-size-100);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-100);
  letter-spacing: var(--font-letter-spacing-loosest);
`;
